// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".form-warp[data-v-086cfd1c]{border:1px dashed #dcdee2;border-radius:10px;padding:10px}.form-warp .title[data-v-086cfd1c]{border-bottom:1px dashed #dcdee2}.form-warp .footer[data-v-086cfd1c]{border-top:1px dashed #dcdee2}", ""]);
// Exports
module.exports = exports;
